const APP_URLS = require('../constants/app-urls');
const { SUPPORTED_SAFARI_VERSION, EDGE_LEGACY_VERSION } = require('../constants/browsers');
const { DEFAULT_LOCALE } = require('../constants/i18n');
const { HOTELS2_MOBILE_URL, HOTELS2_DESKTOP_URL } = require('../constants/urls');
const { HOTEL_AFFILIATE_ID } = require('../constants/identifiers');

const STAGING_BASE_URL = 'https://www.staging.ecosia.org';
const PRODUCTION_BASE_URL = 'https://www.ecosia.org';

const development = {
  API_URL: 'https://api.staging.ecosia.org',
  AUTOCOMPLETE_URL: 'https://ac.staging.ecosia.org',
  ANALYTICS_URL: 'https://analytics-staging.ecosia.org/analytics.js',
  BASE_URL: STAGING_BASE_URL,
  CDN_URL: 'https://cdn-static-staging.ecosia.org',
  INFO_URL: 'https://info.staging.ecosia.org',
  INFO_CDN_URL: 'https://d246arql43mggg.cloudfront.net',
  INDEXPAGE_URL: `${STAGING_BASE_URL}/`,
  MAPS_URL: `${STAGING_BASE_URL}/maps`,
  FEEDBACK_URL: 'https://api.staging.ecosia.org/v1/proxy/zendesk',
  HOTELS_URL: 'https://hotels.staging.ecosia.org/',
};

const staging = {
  API_URL: 'https://api.staging.ecosia.org',
  AUTOCOMPLETE_URL: 'https://ac.staging.ecosia.org',
  ANALYTICS_URL: 'https://analytics-staging.ecosia.org/analytics.js',
  BASE_URL: STAGING_BASE_URL,
  CDN_URL: 'https://cdn-static-staging.ecosia.org',
  INFO_URL: 'https://info.staging.ecosia.org',
  INFO_CDN_URL: 'https://d246arql43mggg.cloudfront.net',
  INDEXPAGE_URL: `${STAGING_BASE_URL}/`,
  MAPS_URL: `${STAGING_BASE_URL}/maps`,
  FEEDBACK_URL: 'https://api.staging.ecosia.org/v1/proxy/zendesk',
  HOTELS_URL: 'https://hotels.staging.ecosia.org/',
};

const production = {
  API_URL: 'https://api.ecosia.org',
  AUTOCOMPLETE_URL: 'https://ac.ecosia.org',
  ANALYTICS_URL: 'https://analytics.ecosia.org/analytics.js',
  BASE_URL: PRODUCTION_BASE_URL,
  CDN_URL: 'https://cdn-static.ecosia.org',
  INFO_URL: 'https://info.ecosia.org',
  INFO_CDN_URL: 'https://d22pcvjllue71e.cloudfront.net',
  INDEXPAGE_URL: `${PRODUCTION_BASE_URL}/`,
  MAPS_URL: `${PRODUCTION_BASE_URL}/maps`,
  FEEDBACK_URL: 'https://api.ecosia.org/v1/proxy/zendesk',
  HOTELS_URL: 'https://hotels.ecosia.org/',
};

const getBingMapsSearchUrl = (query) => `https://www.bing.com/maps?q=${query}`;
const getGoogleMapsSearchUrl = (query) => `https://google.com/maps/search/${query}`;
const getGoogleMapsDirectionUrl = (query) => `https://google.com/maps/dir/?api=1&destination=${query}`;

const getHotelsUrl = ({ language, market, deviceType, currencyCode }) => {
  if (market === 'de-de') {
    if (deviceType === 'mobile') {
      return HOTELS2_MOBILE_URL;
    }
    return HOTELS2_DESKTOP_URL;
  }

  const url = new URL(process.env.hotelsUrl);
  url.searchParams.set('languageCode', language);
  url.searchParams.set('label', `${market}-dropdown`);
  url.searchParams.set('currencyCode', currencyCode);
  url.searchParams.set('a_aid', HOTEL_AFFILIATE_ID);
  return url.toString();
};

const getAppOrExtensionUrl = ({
  os = '',
  browser = '',
  version,
  origin,
  locale = DEFAULT_LOCALE,
  referrerAttributes = {},
}) => {
  const lowerCaseOs = os.toLowerCase();

  if (lowerCaseOs === 'ios') {
    const { ORIGIN, PATHNAME } = APP_URLS.APP_STORE_PARTS;
    return `${ORIGIN}${locale}${PATHNAME}`;
  }

  if (lowerCaseOs === 'android') {
    const url = new URL(APP_URLS.PLAY_STORE);
    url.searchParams.set('hl', locale);

    if (referrerAttributes.tt ||
        referrerAttributes.utm_campaign ||
        referrerAttributes.utm_content
    ) {
      const referrerAttributesString = (new URLSearchParams(referrerAttributes)).toString();
      url.searchParams.set('referrer', encodeURIComponent(referrerAttributesString));
    } else if (origin !== undefined) {
      url.searchParams.set('referrer', origin);
    }
    return url.toString();
  }

  switch (browser.toLowerCase()) {
    case 'chrome':
      return APP_URLS.CHROME_EXTENSION;
    case 'firefox':
      return APP_URLS.FIREFOX_EXTENSION;
    case 'edge':
      // Edge uses chromium as base starting with version > 18
      return parseInt(version, 10) > EDGE_LEGACY_VERSION ?
        APP_URLS.EDGE_EXTENSION :
        APP_URLS.EDGE_INSTALL_INSTRUCTIONS;
    case 'safari':
      // Safari versions lower than 14 have a different way of
      // seeting ECOSIA as default search engine
      return parseInt(version, 10) < SUPPORTED_SAFARI_VERSION ?
        APP_URLS.SAFARI_SET_AS_HOMEPAGE_INSTRUCTIONS :
        APP_URLS.SAFARI_SET_AS_DEFAULT;
    default:
      return APP_URLS.OPEN_SEARCH;
  }
};

const getDevUrl = (port) => `http://local.ecosia.org${port ? `:${port}` : ''}`;

module.exports = {
  development,
  staging,
  production,
  getBingMapsSearchUrl,
  getGoogleMapsSearchUrl,
  getGoogleMapsDirectionUrl,
  getHotelsUrl,
  getAppOrExtensionUrl,
  getDevUrl,
};
